import VideoJs from 'videojs-youtube';

export function init_videoPlayer() {

    var videojs = require('video.js').default;

    // Pak alle video-js elementen
    var videos = document.querySelectorAll('.video-js');
    var video;

    // Loop door videos heen
    for (let i = 0, limit = videos.length; i < limit; i++) {

        video = videos[i];
        // Check of video niet al door videojs is geparsed
        if (video.className.indexOf('vjs') === -1) {
            
            // zet een unieke id (wellicht beter om via craft id te zetten, dit is niet 100% uniek)
            let id = 'video-' + new Date().getTime();
            video.id = id;

            // Initialiseer video met videojs
            videojs(id, JSON.parse(video.getAttribute('data-setup')));

        }

    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/video-player.js